import { ResultPage } from 'runtime/data/resultpage';
import { WorkItemInfo } from 'runtime/data/workiteminfo';
import { BulkActionTarget } from 'runtime/data/bulkactiontarget';

export class WorkTrayPage extends ResultPage<WorkItemInfo> {
    allBulkActionTargets: BulkActionTarget[];
}